import { zodQueryBoolean } from "../../../utils/query";
import { DTOPageBlockDefinition } from "../../dto/documentation/block-definition";
import { z } from "zod";
//
// Read
//
export const DTOGetBlockDefinitionsQuery = z.object({
    files: zodQueryBoolean(),
});
export const DTOGetBlockDefinitionsOutput = z.object({
    definitions: z.array(DTOPageBlockDefinition),
});
